/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Book } from '../models/book';
import { BookSetting } from '../models/book-setting';
import { findBooks } from '../fn/agn-book/find-books';
import { FindBooks$Params } from '../fn/agn-book/find-books';
import { getBookSettings } from '../fn/agn-book/get-book-settings';
import { GetBookSettings$Params } from '../fn/agn-book/get-book-settings';
import { updateBookSetting } from '../fn/agn-book/update-book-setting';
import { UpdateBookSetting$Params } from '../fn/agn-book/update-book-setting';

@Injectable({ providedIn: 'root' })
export class AgnBookService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `updateBookSetting()` */
  static readonly UpdateBookSettingPath = '/api/books/{id}';

  /**
   * Updates a book setting with the given id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateBookSetting()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateBookSetting$Response(params: UpdateBookSetting$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateBookSetting(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates a book setting with the given id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateBookSetting$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateBookSetting(params: UpdateBookSetting$Params, context?: HttpContext): Observable<void> {
    return this.updateBookSetting$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `findBooks()` */
  static readonly FindBooksPath = '/api/books';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findBooks()` instead.
   *
   * This method doesn't expect any request body.
   */
  findBooks$Response(params?: FindBooks$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Book>>> {
    return findBooks(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findBooks$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findBooks(params?: FindBooks$Params, context?: HttpContext): Observable<Array<Book>> {
    return this.findBooks$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Book>>): Array<Book> => r.body)
    );
  }

  /** Path part for operation `getBookSettings()` */
  static readonly GetBookSettingsPath = '/api/books/settings';

  /**
   * To fetch book settings, online animal types, reasons and so on
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBookSettings()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBookSettings$Response(params?: GetBookSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BookSetting>>> {
    return getBookSettings(this.http, this.rootUrl, params, context);
  }

  /**
   * To fetch book settings, online animal types, reasons and so on
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBookSettings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBookSettings(params?: GetBookSettings$Params, context?: HttpContext): Observable<Array<BookSetting>> {
    return this.getBookSettings$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BookSetting>>): Array<BookSetting> => r.body)
    );
  }

}
